import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { MdPersonOutline } from "react-icons/md";
import {
  Header,
  ModuleContainer,
  IconContainer,
  IconStyle,
  ExtentionContainer,
  WorkerContainer,
  Icon,
  WorkerName,
  WStatusSpace,
  WorkDelayedCount,
  RefreshDeleteContainer,
} from "./styles";
import { CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  CustomRemoveIcon,
  CustomRefreshIcon,
  CustomAddIcon,
} from "../../styles";
import { fetchDashboardUsers } from "../../../../../state/dashboard/actions";

const LoadingIndicator = () => (
  <div
    style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
  >
    <CircularProgress />
  </div>
);

const ColaboradoresAtrasados = ({
  item,
  isExpanded,
  toggleExpand,
  isEditing,
  remove,
  restore,
  isExcluded,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const dashUsers = useSelector((state) => state.dashboard.usersProductivity);
  const [lateUsers, setLateUsers] = useState([]);

  const handleUserClick = (userItem) => {
    const userId = userItem._id.trim();
    let searchParams = `userId=${encodeURIComponent(userId)}&status=late`;
    history.push(`/tasks?${searchParams}`);
  };

  useEffect(() => {
    if (dashUsers.status === "succeeded") {
      const filteredAndSortedLateUsers = dashUsers.data
        .filter((user) => user.taskMap.late.length > 0) // Filter users with no late tasks
        .sort((a, b) => b.taskMap.late.length - a.taskMap.late.length); // Sort by number of late tasks

      setLateUsers(filteredAndSortedLateUsers);
    }
  }, [dashUsers]);

  if (dashUsers.status !== "succeeded") {
    return (
      <ModuleContainer>
        <Header>
          <IconContainer>
            <MdPersonOutline style={IconStyle} />
          </IconContainer>
          <LoadingIndicator />
        </Header>
      </ModuleContainer>
    );
  }

  if (dashUsers.status === "succeeded" && lateUsers.length === 0) {
    return (
      <ModuleContainer>
        <Header>
          <IconContainer>
            <MdPersonOutline style={IconStyle} />
          </IconContainer>
          Colaboradores Atrasados: 0
          <RefreshDeleteContainer>
            {isEditing ? (
              !isExcluded ? (
                <CustomRemoveIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    remove();
                  }}
                />
              ) : (
                <CustomAddIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    restore();
                  }}
                />
              )
            ) : (
              <CustomRefreshIcon
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(fetchDashboardUsers());
                }}
              />
            )}
          </RefreshDeleteContainer>
        </Header>
      </ModuleContainer>
    );
  }

  return (
    <ModuleContainer isEditing={isEditing}>
      <Header onClick={toggleExpand}>
        <IconContainer>
          <MdPersonOutline style={IconStyle} />
        </IconContainer>
        Colaboradores Atrasados: {lateUsers.length}
        <RefreshDeleteContainer>
          {isEditing ? (
            !isExcluded ? (
              <CustomRemoveIcon
                onClick={(e) => {
                  e.stopPropagation();
                  remove();
                }}
              />
            ) : (
              <CustomAddIcon
                onClick={(e) => {
                  e.stopPropagation();
                  restore();
                }}
              />
            )
          ) : (
            <CustomRefreshIcon
              onClick={(e) => {
                e.stopPropagation();
                dispatch(fetchDashboardUsers());
              }}
            />
          )}
        </RefreshDeleteContainer>
      </Header>
      {isExpanded && (
        <ExtentionContainer>
          {lateUsers.map((item, index) => (
            <WorkerContainer
              onClick={() => handleUserClick(item)}
              key={"task" + index}
            >
              <Icon>
                <img alt="" title={item.username} src={item.avatarURL} />
              </Icon>
              <WorkerName>{item.username}</WorkerName>
              <WStatusSpace>
                <WorkDelayedCount>{item.taskMap.late.length}</WorkDelayedCount>
              </WStatusSpace>
            </WorkerContainer>
          ))}
        </ExtentionContainer>
      )}
    </ModuleContainer>
  );
};

export default ColaboradoresAtrasados;
